import { render } from "./Intro.vue?vue&type=template&id=ab55d236&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=ab55d236&scoped=true&lang=scss"
import "./Intro.vue?vue&type=style&index=1&id=ab55d236&lang=scss"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab55d236"]])

export default __exports__